import { ButtonIconTransparent } from '@fukku/button/Icon/Transparent'
import { IconCloseBig } from 'icons/components/IconCloseBig'
import { IconMinus } from 'icons/components/IconMinus'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import styles from './ChatHeader.module.scss'

interface ChatHeaderProps {
	readonly onMinimizeDialog: () => void
	readonly onPreventClose: () => void
}

export function ChatHeader({
	onMinimizeDialog,
	onPreventClose,
}: ChatHeaderProps) {
	const { t } = useLabels()

	return (
		<div className={styles.chatHeader}>
			<ButtonIconTransparent className={styles.area} onClick={onMinimizeDialog}>
				<IconMinus rotateRtl={true} alt={t('accessibility.icon.minus.text')} />
			</ButtonIconTransparent>
			<ButtonIconTransparent className={styles.area} onClick={onPreventClose}>
				<IconCloseBig
					width={20}
					height={20}
					alt={t('accessibility.icon.cross.close.text')}
				/>
			</ButtonIconTransparent>
		</div>
	)
}
